/**
 * Actions for Open Ended Questions
 *
 * This file contains action creators related to the management of open ended questions.
 * Action creators are functions that create and return action objects to be dispatched to the Redux store.
 */

/**
 * Action Creator: oeqAnswer
 *
 * Description:
 * Sets the open ended response data in the store.
 *
 * @param {object} data - The open ended question data.
 * @returns {object} - The action object with type and payload.
 */

export function oeqAnswer(payload) {
  return {
    type: "OEQ_ANSWER",
    payload,
  };
}

/**
 * Action Creator: oeqSubmit
 *
 * Description:
 * Submits the open ended data in the store and shows relevant feedback.
 *
 * @param {object} data - The open ended question data.
 * @returns {object} - The action object with type and payload.
 */

export function oeqSubmit(payload) {
  return {
    type: "OEQ_SUBMIT",
    payload,
  };
}
